export default {
  "generic": {
    'top': "Top",
    'home': "Home",
    'about': "About",
    'contact': "Contact",
    'title': "인천대학교 앱센터",
    'about': "인천대학교 앱센터는 인천대학교와, 인천대학교의 학생들을 위한 다양한 모바일 응용프로그램과 서비스를 개발하고 연구하는 인천대학교 교내 동아리입니다.",
  },
}



// WEBPACK FOOTER //
// ./src/locale/ko.js